export default "__VITE_ASSET__17f2336e__"